import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-dashboard-toolbar',
  templateUrl: './dashboard-toolbar.component.html',
  styleUrls: ['./dashboard-toolbar.component.scss']
})
export class DashboardToolbarComponent implements OnInit {

  @Output()
  groupSelect = new EventEmitter<number>();
  groups: any = [
    {value: 0, label: 'Génerale'},
    {value: 1, label: 'Tracteurs'},
    {value: 2, label: 'Outils'},
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

  selectGroup(e: any) {
    this.groupSelect.emit(e.value);
  }
}
